import { Model } from "@vuex-orm/core";
import Media from "./Media";

export default class Resolution extends Model {
  static get entity() {
    return "resolutions";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      majority_id: this.attr(null),
      resolution_catalog_id: this.attr(null),
      // ..
      name: this.attr(null),
      slug: this.attr(null),
      description: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      position: this.attr(null),

      media: this.hasMany(Media, "resolution_id"),

      // ..
      parent_resolution_id: this.attr(null),
      children_resolutions: this.hasMany(Resolution, "parent_resolution_id"),
    };
  }
}
